export default __webpack_public_path__ + "static/media/building6.267397a3.jpeg";